'use strict';

import { appendQueryParams } from '../utils';

export default (API) => ({
    covidScreening: {
        getScreeningDemands(payload) {
            let url = appendQueryParams(`v3/screeningDemands/nosotech`, payload);

            const request = API.http.get(url);
            return API.handleError(request);
        },

        fetchAppointmentsDemands(requestUuid, params) {
            let url = `v3/appointments/${requestUuid}/screeningInfo/nosotech?${new URLSearchParams(params).toString()}`;
            const request = API.http.get(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        updateScreeningDemand(screeningDemandId, params) {
            const url = 'v3/screeningDemands/nosotech/' + screeningDemandId;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        createScreeningResult(screeningDemandId, params) {
            const url = 'v3/screeningResults/nosotech/' + screeningDemandId;

            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        updateScreeningResult(screeningResultId, params) {
            const url = 'v3/screeningResults/nosotech/' + screeningResultId;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        sendNosotechScreeningResultCommunication(screeningDemandId) {
            const url = `v3/screeningDemands/nosotech/${screeningDemandId}/sendCommunication`;
            const request = API.http.post(url, {}, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
    },
});
